import { render, staticRenderFns } from "./PreviousOkr.vue?vue&type=template&id=3646149c&"
import script from "./PreviousOkr.vue?vue&type=script&lang=js&"
export * from "./PreviousOkr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports